import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=3d888b09&scoped=true&"
import script from "./app-footer.vue?vue&type=script&lang=js&"
export * from "./app-footer.vue?vue&type=script&lang=js&"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=3d888b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d888b09",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFooter,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d888b09')) {
      api.createRecord('3d888b09', component.options)
    } else {
      api.reload('3d888b09', component.options)
    }
    module.hot.accept("./app-footer.vue?vue&type=template&id=3d888b09&scoped=true&", function () {
      api.rerender('3d888b09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-footer/app-footer.vue"
export default component.exports